/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-modal {
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  padding: 10px;
  pointer-events: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 4000;
}
.ux-modal.ux-modal--sticky-bottom {
  justify-content: flex-end;
}
.ux-modal.ux-modal--sticky-top {
  justify-content: flex-start;
}
@media (width <= 767px) {
  .ux-modal {
    align-items: stretch;
  }
}
@media (width >= 1024px) {
  .ux-modal {
    padding: 15px;
  }
}
.ux-modal--closed {
  display: none;
}
.ux-modal__backdrop {
  backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.ux-modal--opening .ux-modal__backdrop {
  opacity: 0;
}
.ux-modal--opened .ux-modal__backdrop {
  opacity: 1;
  transition: opacity 250ms ease-out;
}
.ux-modal--closing .ux-modal__backdrop {
  opacity: 0;
  transition: opacity 250ms ease-out;
}
.ux-modal--closed .ux-modal__backdrop {
  opacity: 0;
}
.ux-modal__outer {
  display: flex;
  max-height: 100%;
  max-width: 100%;
  position: relative;
}
@media (width >= 768px) {
  .ux-modal__outer {
    width: 83.3333%;
  }
}
@media (width >= 1024px) {
  .ux-modal__outer {
    max-width: 960px;
    width: 66.6666%;
  }
}
.ux-modal__inner {
  align-items: stretch;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  max-height: 100%;
  width: 100%;
}
.ux-modal--opening .ux-modal__inner {
  opacity: 0;
  transform: scale(0.95);
}
.ux-modal--opened .ux-modal__inner {
  opacity: 1;
  transform: none;
  transition: opacity 250ms ease-out, transform 250ms ease-out;
}
.ux-modal--closing .ux-modal__inner {
  opacity: 0;
  transform: scale(0.95);
  transition: opacity 250ms ease-out, transform 250ms ease-out;
}
.ux-modal--closed .ux-modal__inner {
  transform: scale(0.95);
}
.ux-modal__head {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  height: 40px;
  justify-content: flex-end;
}
.ux-modal__slot {
  align-items: stretch;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: stretch;
  max-height: calc(100% - 40px);
  width: 100%;
}
.ux-modal__close {
  appearance: none;
  background: transparent;
  border: 0 none transparent;
  cursor: pointer;
  height: 40px;
  margin: 0;
  outline: none;
  padding: 0;
  width: 40px;
}
.ux-modal__multi {
  border-bottom: 1px solid #eaedf2;
  padding: 15px 0;
  width: 100%;
}
.ux-modal__multi .ux-steps {
  margin: 0 auto;
  max-width: 500px;
}
.ux-modal--no-gutter-top .ux-modal__head {
  position: absolute;
  width: 100%;
}